import sc from 'styled-components';
// import c from 'chroma-js';
import React from 'react';
import { PageHeader } from './typography';
import {
  BLUE_LIGHT, BLACK, GRAY_LIGHT,
  CODE_FONT_FAMILY,
  HEADLINE_FONT_FAMILY,
  ACCENT_ORANGE,
  BREADCRUMB_FONT_SIZE,
  HEADER_FONT_SIZE,
} from './styleConstants';

const HeadlineBreadcrumb = sc.nav`
  flex: auto;
`;

HeadlineBreadcrumb.List = sc.div`
display: flex;
flex-direction: row;
justify-content: flex-start;
align-items: baseline;
font-size: ${HEADER_FONT_SIZE};
`;

HeadlineBreadcrumb.Cell = sc.div`
font-family: ${HEADLINE_FONT_FAMILY};
color: ${BLUE_LIGHT};
white-space: nowrap;
font-weight: normal;
text-transform: uppercase;
font-size: ${BREADCRUMB_FONT_SIZE};
`;
HeadlineBreadcrumb.CellSeperator = sc.div`
font-family: ${HEADLINE_FONT_FAMILY};
color: ${ACCENT_ORANGE};
margin-left: 0.5rem;
margin-right: 0.5rem;
white-space: nowrap;
font-weight: normal;
font-size: ${BREADCRUMB_FONT_SIZE};
`;
HeadlineBreadcrumb.CellFinal = PageHeader;

export default HeadlineBreadcrumb;
